<template>
  <div class="news center clearflx">
    <bg :pcImg='pcBannerImg' :mobileImg='mobileBannerImg'>
      <scroll-nav :active-index='this.$route.params.catid' :list='newsTypeList' cusValue='cat_id' cusKey='cat_name' @scrollNavClick='scrollNavClick'></scroll-nav>
    </bg>


    <!-- 三级路由，新闻 -->
    <div class="new-wrap center">
      <transition name="move" mode="out-in">
        <router-view ref="aa" :key="new Date().getTime()"></router-view>
      </transition>
    </div>


  </div>
</template>

<script>
import BG from '../components/common/BG'
import ScrollNav from '../components/common/ScrollNav'
import {selectArticleCat} from '../api/article/selectArticleCat'

export default {
  data() {
    return {
      pcBannerImg: require('../assets/img/two_banner_bg4.jpg'),
      mobileBannerImg: require('../assets/img/two_banner_mobile_bg4.jpg'),
      newsTypeList:[],
    }
  },
  components: {
    bg:BG,
    ScrollNav,
  },
  methods: {
    scrollNavClick(e) {
      this.$router.push({name: 'newtype',params: { catid: e.cat_id }})
    },
    // 获取新闻分类
    getNewsTypeList() {
      selectArticleCat({catType:1}).then(res => {
        this.newsTypeList = res.data;
      }).catch((err) => {
        this.$message.error(err.message);
      })
    },
  },
  created() {
    // 获取新闻分类
    this.getNewsTypeList();
  },
  
}
</script>

<style lang="scss" scoped>
@import '../assets/css/register.scss';
@import '../assets/css/base.scss';

  .new-wrap {
    width: 1200px;
    // background-color: pink;
  }
  @media screen and(max-width: 1200px) {
    .new-wrap {
      width: 1000px;
    }
  }

  @media screen and (max-width: 768px){
    .new-wrap {
      width: 100%;
      margin: 0 auto;
    }
  }
</style>